var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#208ce1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 55,
    height: 55,
    transform: "translate(1024 1223)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-1024 -1223)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1012 1219)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M50.8,5H29.2A4.174,4.174,0,0,0,25,9.2V54.8A4.174,4.174,0,0,0,29.2,59H50.8A4.174,4.174,0,0,0,55,54.8V9.2A4.174,4.174,0,0,0,50.8,5ZM27.4,14.6H52.6V49.4H27.4Zm1.8-7.2H50.8a1.768,1.768,0,0,1,1.8,1.8v3H27.4v-3A1.768,1.768,0,0,1,29.2,7.4ZM50.8,56.6H29.2a1.768,1.768,0,0,1-1.8-1.8v-3H52.6v3A1.768,1.768,0,0,1,50.8,56.6ZM37,9.8a1.2,1.2,0,0,1,1.2-1.2h3.6a1.2,1.2,0,0,1,0,2.4H38.2A1.2,1.2,0,0,1,37,9.8Zm4.2,44.4A1.2,1.2,0,1,1,40,53,1.2,1.2,0,0,1,41.2,54.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.7477e0d3622bb6ad9f4bbb032d912363.svg";
export { ForwardRef as ReactComponent };